import React from "react";
import lessonReducer from "../reducers/lesson";
import { lesson, requestState } from "../actions";
import axios from "axios";
const LessonContext = React.createContext();
export const LessonProvider = ({ children }) => {
	const initialState = {
		lessons: null,
		lessonFilter: null,
		pronunciations: null,
		pronunciationFilter: null,
		tips: null,
		tipFilter: null,
		lesson: null,
		loading: false,
		error: null,
		success: null,
		lessonTotal: null,
		pronunciationTotal: null,
		tipsTotal: null,
		nextLesson: null,
	};

	const [lessonState, dispatch] = React.useReducer(lessonReducer, initialState);

	const isLoading = () => {
		dispatch({
			type: requestState.LOADING,
		});
	};

	const countLessons = async () => {
		try {
			const res = await axios.get(`/lessons/getDistinct`);

			dispatch({
				type: lesson.COUNT_LESSONS,
				payload: res.data,
			});
		} catch (error) {
			dispatch({
				type: requestState.ERROR,
				payload: error.response ? error.response.data.message : "Connection failed" || error.message,
			});
		}
	};

	const filterLessons = (value) => {
		dispatch({
			type: lesson.FILTER_LESSON,
			payload: value,
		});
	};

	const filterTips = (value) => {
		dispatch({
			type: lesson.FILTER_TIPS,
			payload: value,
		});
	};

	const filterPronunciations = (value) => {
		dispatch({
			type: lesson.FILTER_PRONUNCIATION,
			payload: value,
		});
	};
	//Get  lessons
	const getLessons = async (options, level) => {
		isLoading();
		try {
			const res = await axios.get(`/lessons/page/${options.page}/limit/${options.limit}`, {
				params: {
					category: "lesson",
					level: level,
				},
			});

			dispatch({
				type: lesson.GET_LESSONS,
				payload: res.data,
			});
		} catch (error) {
			dispatch({
				type: requestState.ERROR,
				payload: error.response ? error.response.data.message : "Connection failed" || error.message,
			});
		}
	};

	const getNextLessons = async (options, level) => {
		//isLoading();
		try {
			const res = await axios.get(`/lessons/page/${options.page}/limit/${options.limit}`, {
				params: {
					category: "lesson",
					level: level,
				},
			});

			dispatch({
				type: lesson.GET_NEXT_LESSONS,
				payload: res.data,
			});
		} catch (error) {
			//console.log(error);
			dispatch({
				type: requestState.ERROR,
				payload: error.response ? error.response.data.message : "Connection failed" || error.message,
			});
		}
	};
	const getLesson = async (_id,category) => {
		isLoading();
		try {
			const res = await axios.get(`/lesson/${_id}`);
			dispatch({
				type: lesson.GET_LESSON,
				payload: {
					lesson: res.data.lesson,
					nextLesson: res.data.nextItems,
				},
			});
		} catch (error) {
			dispatch({
				type: requestState.ERROR,
				payload: error.response ? error.response.data.message : "Connection failed" || error.message,
			});
		}
	};

	const getTips = async (options) => {
		isLoading();
		try {
			const res = await axios.get(`/lessons/page/${options.page}/limit/${options.limit}`, {
				params: {
					category: "Tips&Tricks",
				},
			});
			dispatch({
				type: lesson.GET_TIPS,
				payload: res.data,
			});
		} catch (error) {
			dispatch({
				type: requestState.ERROR,
				payload: error.response ? error.response.data.message : "Connection failed" || error.message,
			});
		}
	};

	const getPronunciations = async (options) => {
		isLoading();
		try {
			const res = await axios.get(`/lessons/page/${options.page}/limit/${options.limit}`, {
				params: {
					category: "Pronunciation",
				},
			});
			//console.log(res.data);
			dispatch({
				type: lesson.GET_PRONUNCIATION,
				payload: res.data,
			});
		} catch (error) {
			dispatch({
				type: requestState.ERROR,
				payload: error.response ? error.response.data.message : "Connection failed" || error.message,
			});
		}
	};

	const getFollowingLessons = async (options, type, category) => {
		//isLoading();
		try {
			const res = await axios.get(`/lessons/page/${options.page}/limit/${options.limit}`, {
				params: {
					category: category,
				},
			});
			//console.log(res.data)
			dispatch({
				type: type,
				payload: res.data,
			});
		} catch (error) {
			//console.log(error);
			dispatch({
				type: requestState.ERROR,
				payload: error.response ? error.response.data.message : "Connection failed" || error.message,
			});
		}
	};

	const clearCurrentLesson = () => {
		dispatch({
			type: lesson.CLEAR_CURRENT_LESSON,
		});
	};

	// Clear Errors
	const clearNotification = () =>
		dispatch({
			type: requestState.CLEAR_NOTIFICATION,
		});
	return (
		<LessonContext.Provider
			value={{
				loading: lessonState.loading,
				error: lessonState.error,
				clearNotification: clearNotification,
				isLoading: isLoading,
				success: lessonState.success,
				lessons: lessonState.lessons,
				lesson: lessonState.lesson,
				pronunciations: lessonState.pronunciations,
				tips: lessonState.tips,
				tipsTotal: lessonState.tipsTotal,
				lessonTotal: lessonState.lessonTotal,
				pronunciationTotal: lessonState.pronunciationTotal,
				countLessons: countLessons,
				getLesson: getLesson,
				getTips: getTips,
				getPronunciations: getPronunciations,
				getLessons: getLessons,
				filterLessons: filterLessons,
				filterPronunciations: filterPronunciations,
				filterTips: filterTips,
				tipFilter: lessonState.tipFilter,
				pronunciationFilter: lessonState.pronunciationFilter,
				lessonFilter: lessonState.lessonFilter,
				getNextLessons: getNextLessons,
				clearCurrentLesson: clearCurrentLesson,
				nextLesson: lessonState.nextLesson,
				getFollowingLessons: getFollowingLessons,
			}}
		>
			{children}
		</LessonContext.Provider>
	);
};

export const useLessonContext = () => React.useContext(LessonContext);
